if (!customElements.get('call-action-visibility')) {
  customElements.define('call-action-visibility', class CallActionVisibility extends HTMLElement {
    connectedCallback() {
      this.pulseTarget = this.querySelector('.call-action--pulse');
      this.container = this.closest('.section__container');
      if (!this.container) return;

      this.handleIntersect = this.handleIntersect.bind(this);
      this.observer = new IntersectionObserver(this.handleIntersect, {
        rootMargin: '400px 0px 400px 0px'
      });

      this.updateState(this.isInViewport());
      this.observer.observe(this.container);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.classList.remove('call-action-visibility--running');
      this.container?.classList.remove('call-action-pulse--running');
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.target !== this.container) return;
        this.updateState(entry.isIntersecting);
      });
    }

    isInViewport() {
      if (!this.container) return false;
      const rect = this.container.getBoundingClientRect();
      return rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < window.innerHeight &&
        rect.left < window.innerWidth;
    }

    updateState(isRunning) {
      this.classList.toggle('call-action-visibility--running', Boolean(isRunning));
      if (this.pulseTarget) {
        this.container?.classList.toggle('call-action-pulse--running', Boolean(isRunning));
      } else {
        this.container?.classList.remove('call-action-pulse--running');
      }
    }
  });
}
